// test2796
(2796 && 0);
